import { DevicePhoneMobileIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import useUserDetails from "../hooks/useUserDetails";
import { siteConfig } from "../siteConfig";

function MobileAppBanner() {
  const { userDetails } = useUserDetails();
  const [isVisible, setIsVisible] = useState(true);

  if (!userDetails || userDetails.last_mobile_app_login || !isVisible) {
    return null;
  }

  return (
    <div className="md:hidden fixed top-8 left-4 right-4 z-50 bg-terracotta-600 text-white py-2 px-4 rounded-lg flex items-center">
      <div className="flex items-center gap-2 flex-1 justify-center">
        <DevicePhoneMobileIcon className="w-5 h-5" />
        <div className="flex gap-3">
          <a
            href={siteConfig.iosAppStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium"
          >
            iOS
          </a>
          <span className="text-terracotta-200">|</span>
          <a
            href={siteConfig.androidPlayStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium"
          >
            Android
          </a>
        </div>
      </div>
      <button
        onClick={() => setIsVisible(false)}
        className="text-white hover:text-gray-200 transition-colors ml-2"
        aria-label="Close banner"
      >
        <svg
          className="w-5 h-5"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
  );
}

export default MobileAppBanner;
